import { Box, Typography, useMediaQuery, useTheme, Fab } from '@mui/material'
import ChatIcon from '@mui/icons-material/Chat'

import { HelperWrapper } from 'src/components'

export const AccountWelcome = () => {
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const handleHelpClick = () => {
    // @ts-ignore
    window.Intercom('show')
  }

  return (
    <Box
      sx={{
        width: isTablet ? '100%' : '650px',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'start',
        mb: 10,
      }}
    >
      <video style={{ width: '100%', height: 'auto' }} controls autoPlay muted>
        <source
          src="https://s3.eu-central-1.amazonaws.com/cdn-dev.trackgood.io/4b389776-f614-4fe3-8224-6b566738f7e0.mp4"
          type="video/mp4"
        />
      </video>

      <Typography variant="body2" sx={{ mt: 3, mb: 3 }}>
        <HelperWrapper t="dashboard-welcome-text" />
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 500 }}>
        <HelperWrapper t="dashboard-welcome-supurt-title" />
      </Typography>
      <Typography variant="body2" sx={{ mt: 2, mb: 3 }}>
        <HelperWrapper t="dashboard-welcome-supurt-text" />
      </Typography>

      <Fab
        sx={{ width: 50, height: 50 }}
        color="primary"
        aria-label="chat"
        onClick={handleHelpClick}
      >
        <ChatIcon />
      </Fab>
    </Box>
  )
}
